import { ClassicType } from './../../../shared/models/ClassicType';
import { Subscription } from 'rxjs';
import { ApiRestService } from './../../_service/api-rest.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Sede } from './../../models/Sede';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AziendeStoreService } from '../../_service/aziende-store.service';
import { Azienda } from '../../models/Azienda';
import {Permission} from "../../../Login/_guards/Permission";
import { environment } from 'src/environments/environment';
import {ProvaAcquisto} from "../../../rma/_Models/prova-acquisto";
import {Rma} from "../../../rma/_Models/rma";
import {RmaProdottoAddComponent} from "../../../rma/rma-add/rma-prodotto-add.component";
import {RmaStoreService} from "../../../rma/_services/rma-store.service";
import {CampoUtility} from "../../../shared/models/campo-aggiuntivo";

@Component({
  selector: 'app-sedi-aggiuntive',
  templateUrl: './sedi-aggiuntive.component.html'
})
export class SediAggiuntiveComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  environment = environment;
  @Input() listaSedi: Sede[];
  @Output() listaSediChange = new EventEmitter();
  sediFiltrate: Sede[];
  @Input() profile: boolean;
  @Input() client_id: number;
  @Input() client: Azienda;
  @Output() Saved = new EventEmitter();
  selectedSede: Sede = undefined;
  form: FormGroup;
  dropdownSettings = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    idField: 'id',
    textField: 'label',
    itemsShowLimit: 5,
    allowSearchFilter: true,
  };
  DropdownSources: any = {
    tipologieSedi: []
  };
  Filters = {};

  constructor(
    private formbuilder: FormBuilder,
    private modalService: NgbModal,
    private apiRestService: ApiRestService,
    public aziendeStore: AziendeStoreService,
    public permission: Permission,
    private RmaStore: RmaStoreService,
    private campiUtility: CampoUtility
  ) {
    this.form = this.formbuilder.group({
      indirizzo: ['', Validators.required],
      cap: ['', Validators.required],
      citta: ['', Validators.required],
      provincia: ['', Validators.required],
      email: [''],
      telefono: [''],
      fax: [''],
      note: [''],
    });
   }

  ngOnInit() {
    this.aziendeStore.getTipologieSedi();
    this.subscriptions.add(this.aziendeStore.$tipologieSedi.subscribe((items) => {
      if (items && items !== null)
        this.DropdownSources.tipologieSedi = items;
    }));
    this.refresh();
  }
  saveModalButton() {
    this.selectedSede.tipiSede = this.indexArray(this.selectedSede.tipiObject);
    if (this.selectedSede && !isNaN(this.selectedSede.id))
      this.apiRestService.updateSedi(this.selectedSede).subscribe(data => {
        this.Saved.emit();
        this.closeBtnClick()
      });
    else if (this.selectedSede && (isNaN(this.selectedSede.id) || this.selectedSede.id < 1))
      this.apiRestService.addNewSedi(this.selectedSede).subscribe(data => {
        this.Saved.emit();
        this.closeBtnClick()
      });
  }
  indexArray(input: ClassicType[]) {
    const output: number[] = [];
    if(input && input[0])
      input?.forEach(data => output?.push(parseInt(data?.id)));
    return output;
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
  openModal(targetModal: NgbModal, sede: Sede) {
    if(this.permission.isPermitted('gestione-sedi') || this.profile) {
      if (sede == null) {
        this.selectedSede = new Sede();
        this.selectedSede.tipiObject = [this.DropdownSources.tipologieSedi[0]];
      } else
        this.selectedSede = sede;
      this.selectedSede.cliente = this.client_id;
      this.modalService.open(targetModal, {
        size: 'xl',
        centered: true,
        backdrop: 'static'
      });
    }
  }
  refresh(){
    this.sediFiltrate = [...this.listaSedi]
    if(environment['ClientiAddOn'] && environment.ClientiAddOn['FiltriSede'])
      this.sediFiltrate = this.campiUtility.getFilteredList(this.sediFiltrate, environment.ClientiAddOn['FiltriSede'], this.Filters);
  }
  delete(item: Sede) {
    if (confirm("Sei sicuro di voler eliminare questa sede?"))
      this.apiRestService.deleteSede(item).subscribe(data => {
        this.aziendeStore.Refresh_data();
      });
  }

  AddRma() {
    const newRma =  new Rma(undefined);
    newRma.acquirente = Object.assign({}, this.client);
    newRma.ritiro = Object.assign({}, this.client);
    newRma.acquirente.referente = this.client?.referenti?.length > 0? (this.client?.referenti[0]?.cognome + " " + this.client?.referenti[0]?.nome) : "";
    newRma.ritiro.referente = this.client?.referenti?.length > 0? (this.client?.referenti[0]?.cognome + " " + this.client?.referenti[0]?.nome) : "";
    newRma.proveObject = [];
    newRma.sedeId = this.selectedSede?.id;
    newRma.sedeObject = this.selectedSede;
    newRma.clienteObject = Object.assign({}, this.client);
    this.RmaStore.updateSelected(newRma);
    const editmodal = this.modalService.open(RmaProdottoAddComponent, { centered: true, backdrop: 'static', size: 'xl',});
    (<RmaProdottoAddComponent>editmodal.componentInstance).onClose.subscribe (data => this.refresh() )
  }

}
